<template>
  <div class="page-wrapper repaymentplan">
    <navbar back fixed bg>
      <span slot="title">还款计划</span>
    </navbar>
    <div class="page-content" :class="{noTop: isWechat}">
      <div class="plan-list">
        <div class="list-item" v-for="(item, index) in repaymentPlanList" :key="index">
          <div class="list-item-header">
            <span class="title">到期日期: </span>
            <span class="date decimal">{{item.endDate}}</span>
            <a href="javascript:;" class="repaymentstatus">{{item.status}}</a>
          </div>
          <div class="item-group clearfix">
            <div class="item-label">
              <div class="label">应还本金</div>
              <div class="label">应还利息</div>
            </div>
            <div class="item-value">
              <div class="value decimal">{{item.principal == null ? '--' : item.principal}}</div>
              <div class="value decimal">{{item.normalInterest == null ? '--' : item.normalInterest}}<span class="small">{{item.unit}}</span></div>
            </div>
          </div>
          <div class="line"></div>
          <div class="item-group clearfix">
            <div class="item-label">
              <div class="label">剩余本金</div>
              <div class="label">期数</div>
            </div>
            <div class="item-value">
              <div class="value decimal">{{item.remainPrincipal == null ? '--' : item.remainPrincipal}}</div>
              <div class="value decimal">{{item.phaseNum == null ? '--' : item.phaseNum}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <spinner :show="loading"></spinner>
  </div>
</template>

<script>
import Navbar from 'components/navbar/navbar'
import Spinner from 'components/spinner/spinner'

export default {
  components: {
    Navbar,
    Spinner
  },
  data () {
    return {
      isWechat: false,
      toastShow: false,
      toastText: '',
      loading: false,
      repaymentPlanList: []
    }
  },
  created () {
    if (this.$device.isWechat) {
      this.isWechat = true
    }
  },
  mounted () {
    this.token = this.$cache.getUserToken()
    this.orderNo = this.$route.params.orderNo
    this.getRepaymentPlanList()
  },
  methods: {
    getRepaymentPlanList () {
      this.loading = true
      return this.$ajax({
        url: '/center/queryRepaymentPlan.jhtml',
        params: {
          no: this.orderNo,
          uid: this.token.uid
        },
        done: (data) => {
          this.repaymentPlanList = data
        },
        always: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.plan-list {
  overflow auto
  height 100%
  padding: 16px 8px;
  .list-item {
    padding: 11px 10px 22px 10px;
    margin-bottom: 26px;
    border-radius: 2px;
    background-color: rgba(255,255,255,0.86);
    position: relative;
    box-shadow:0px 5px 8px 0px rgba(171,185,197,1);
    &.all .value {
      padding-bottom: 10px;
    }
    .line {
      height: 1px;
      margin: 20px 0 17px;
      background-color: rgba(239,246,253,1);
    }
    .item-label, .item-value {
      display: table;
      width: 100%;
    }
    .label {
      color: #4E465A;
      font-size: 11px;
      line-height: 16px;
      padding-bottom: 10px;
      letter-spacing: 0.38px;
    }
    .value {
      font-size: 19px;
      line-height: 28px;
      color: #275482;
    }
    .small {
      font-size: 12px;
      line-height: 16px;
    }
    .item-group {
      .label, .value {
        width: 50%;
        display: table-cell;
        vertical-align: middle;
      }
    }
  }
  .list-item-header {
    margin-bottom: 25px;
    line-height: 22px;
    .title, .date {
      font-size: 17px;
      vertical-align: middle;
      height: 22px;
      line-height: 22px;
      color: #275482;
      font-weight: bold;
    }
    .title {
      font-weight: bold;
    }
    .repaymentstatus {
      float: right;
      font-size: 10px;
      color: #fff;
      text-align: center;
      width: 50px;
      height: 18px;
      line-height: 18px;
      background: rgba(18,159,221,1);
      box-shadow: 0px 0px 2px 0px rgba(18,119,163,0.75);
      border-radius: 9px;
    }
  }
}

.noTop{
  top: 0 !important;
}
</style>



// WEBPACK FOOTER //
// repaymentplan.vue?942dd3fc